<template>
  <div class="mt-16" v-for="question in getQuestions" :key="question.id">
    <SingleQuestion
      :questionName="question.uf_name"
      :questionDate="question.date"
      :questionText="question.uf_comment"
      questionClass="grid-col_full"
    />
    <Answer :text="question.uf_answer" />
  </div>

  <div class="grid-row d-flex_sm-wrap grid-row_md mt-16 d-flex_between">
    <div class="grid-col grid-col_sm-100 pt-8">
      <PopupLeaveQuestion />
    </div>
    <div
      class="grid-col grid-col_sm-100 pt-8"
      v-if="this.countMore < getQuestionsCount"
    >
      <div
        class="btn btn_lg btn_stroke-dark-soft btn_px-lg border-radius-md"
        type="button"
        @click="
          () => {
            countMore += 5;
          }
        "
      >
        Показать еще
      </div>
    </div>
  </div>
</template>

<script>
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import SingleQuestion from "../SingleQuestion/SingleQuestion.vue";
import Answer from "../Answer/Answer.vue";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { mapState } from "pinia";
import PopupLeaveQuestion from "../Popups/PopupLeaveQuestion.vue";

export default {
  name: "SliderQuestions",
  components: {
    SingleQuestion,
    Answer,
    PopupLeaveQuestion,
  },
  data() {
    return {
      countMore: 5,
    };
  },
  setup() {
    const storeReviews = useReviewsStore();

    return {
      storeReviews,
    };
  },
  computed: {
    ...mapState(useReviewsStore, [
      "getQuestionsForSlider",
      "getQuestionsCount",
    ]),
    getQuestions() {
      return this.getQuestionsForSlider.slice(0, this.countMore);
    },
  },
  methods: {
    openQuestionsPopup() {
      this.store.questionsPopupOpen = true;
    },
  },
};
</script>

<style lang="scss">
@import "./slider.scss";
</style>
